import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftLucky"
  }, [_c('n-new-head', {
    ref: "nNewHeadRef"
  }), _c('div', {
    staticClass: "nftLucky-body page-body"
  }, [_c('div', {
    staticClass: "nftLucky-main page-main"
  }, [_c('div', {
    staticClass: "nftLucky-draw",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucy-bg.jpg')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-body",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-title",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky_title.png')}) center top/auto 100% no-repeat`
    }
  }, [_vm._v("Shard Draw")]), _c('div', {
    staticClass: "nftLucky-draw-main"
  }, _vm._l(_vm.prizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nftLucky-draw-item"
    }, [index !== 4 ? _c('div', {
      staticClass: "nftLucky-draw-item-main",
      style: {
        background: `url(${require(_vm.highlightIndex === index ? '@images/tapcoin/new/niceLucky/niceLucky-item-active-bg.png' : '@images/tapcoin/new/niceLucky/niceLucky-item-bg.png')}) center top/100% auto no-repeat`
      }
    }, [item.amount == 0 ? _c('div', {
      staticClass: "nftLucky-draw-item-fail"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/CRY.png`),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "nftLucky-draw-item-reward"
    }, [_c('div', {
      staticClass: "nftLucky-draw-item-reward__label"
    }, [_vm._v("NFT Shards")]), _c('div', {
      staticClass: "nftLucky-draw-item-reward__img"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "nftLucky-draw-item-tag"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.amount)))])])])]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "nftLucky-draw-ship",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/ship-num.png')}) center top/auto 100% no-repeat`
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.NFTBalance)))])]), _vm.luckyInfo && JSON.stringify(_vm.luckyInfo) != '{}' ? [_c('div', {
    staticClass: "nftLucky-draw-btns",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky-bottom.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btns-main",
    class: Object.keys(_vm.priceList).length == 2 && 'two'
  }, _vm._l(_vm.priceList, function (value, key, index) {
    return _c('div', {
      key: key,
      staticClass: "nftLucky-draw-btn",
      on: {
        "click": function ($event) {
          return _vm.onStart(key, value);
        }
      }
    }, [[Object.keys(_vm.priceList).length == 1 ? [_c('div', {
      staticClass: "nftLucky-draw-btn-bg",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-2.png')}) center top/100% auto no-repeat`
      }
    })] : Object.keys(_vm.priceList).length == 2 ? [index == 0 ? _c('div', {
      staticClass: "nftLucky-draw-btn-bg",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
      }
    }) : index == 1 ? _c('div', {
      staticClass: "nftLucky-draw-btn-bg three",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
      }
    }) : _vm._e()] : Object.keys(_vm.priceList).length == 3 ? [index == 0 ? _c('div', {
      staticClass: "nftLucky-draw-btn-bg",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
      }
    }) : index == 1 ? _c('div', {
      staticClass: "nftLucky-draw-btn-bg",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-2.png')}) center top/100% auto no-repeat`
      }
    }) : index == 2 ? _c('div', {
      staticClass: "nftLucky-draw-btn-bg three",
      style: {
        background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
      }
    }) : _vm._e()] : _vm._e()], _c('div', {
      staticClass: "nftLucky-draw-btn__title"
    }, [_vm._v("SPIN")]), !value.isLoading ? _c('div', {
      staticClass: "nftLucky-draw-btn__price"
    }, _vm._l(value, function (val, ke) {
      return _c('span', {
        key: ke,
        style: {
          display: (!val || key == 'isLoading' || key == 'deposit_id') && 'none'
        }
      }, [val ? [ke == 'price_stock' ? _c('img', {
        attrs: {
          "src": require(`@images/tapcoin/new/TAPSTOCK-small.png`),
          "alt": ""
        }
      }) : ke == 'price_tap' ? _c('img', {
        attrs: {
          "src": require(`@images/tapcoin/new/TAP-small.png`),
          "alt": ""
        }
      }) : ke == 'price_coin' ? _c('img', {
        attrs: {
          "src": require(`@images/tapcoin/new/TAPCOINS-small.png`),
          "alt": ""
        }
      }) : ke == 'price_stars' ? _c('img', {
        attrs: {
          "src": require(`@images/tapcoin/ton-stars.png`),
          "alt": ""
        }
      }) : ke == 'price_ton' ? _c('img', {
        attrs: {
          "src": require(`@images/tapcoin/BIGTON.png`),
          "alt": ""
        }
      }) : _vm._e(), ke == 'price_stock' ? _c('em', {
        class: _vm.$refs?.nNewHeadRef?.balance.stock.balance < val && 'err'
      }, [_vm._v(" " + _vm._s(_vm.fmt_pre(val)))]) : ke == 'price_tap' ? _c('em', {
        class: _vm.$refs?.nNewHeadRef?.balance.tap.balance < val && 'err'
      }, [_vm._v(" " + _vm._s(_vm.fmt_pre(val)))]) : ke == 'price_coin' ? _c('em', {
        class: _vm.$refs?.nNewHeadRef?.balance.coin.balance < val && 'err'
      }, [_vm._v(" " + _vm._s(_vm.fmt_pre(val)))]) : ke == 'price_stars' ? _c('em', {
        class: _vm.$refs?.nNewHeadRef?.balance.Stars.balance < val && 'err'
      }, [_vm._v(" " + _vm._s(_vm.fmt_pre(val)))]) : ke == 'price_ton' ? _c('em', {
        class: _vm.$refs?.nNewHeadRef?.balance.ton.balance < val && 'err'
      }, [_vm._v(" " + _vm._s(_vm.fmt_pre(val)))]) : _vm._e()] : _vm._e()], 2);
    }), 0) : _c('div', {
      staticClass: "nftLucky-draw-btn-loading"
    }, [_c('div', {
      staticClass: "circleLoading"
    })])], 2);
  }), 0)])] : _vm.luckyInfo && JSON.stringify(_vm.luckyInfo) == '{}' ? [_c('div', {
    staticClass: "nftLucky-draw-btns",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky-bottom.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btns-maintain"
  }, [_c('div', {
    staticClass: "nftLucky-draw-btns-maintain-main",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm._v(" Under maintenance "), _c('div', {
    staticClass: "icon-refresh"
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)])])])] : _vm._e()], 2), _c('div', {
    staticClass: "nftLucky-history"
  }, [_c('div', {
    staticClass: "history__title"
  }, [_vm._v("Draw History")]), _c('div', {
    staticClass: "history-list"
  }, _vm._l(_vm.luckyLogs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "history-item"
    }, [_c('div', {
      staticClass: "history-item__reward"
    }, [item.item_amount <= 0 ? _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/CRY.png`),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "history-item__price",
      class: item.item_amount <= 0 && 'noReward'
    }, [item.item_amount <= 0 ? [_vm._v(" No reward ")] : [_vm._v("+" + _vm._s(_vm.fmt_pre(item.item_amount)))]], 2)]);
  }), 0)])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1), _c('pop-reward', {
    attrs: {
      "show": _vm.popRewardShow,
      "data": _vm.rewardData
    },
    on: {
      "update:show": function ($event) {
        _vm.popRewardShow = $event;
      },
      "finish": _vm.popRewardFinish
    }
  }), _c('pop-dialog', {
    attrs: {
      "show": _vm.insufficientBalanceShow
    },
    on: {
      "update:show": function ($event) {
        _vm.insufficientBalanceShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popInsufficientBalance"
  }, [_c('div', {
    staticClass: "popInsufficientBalance__title"
  }, [_vm._v("Insufficient balance")]), _c('div', {
    staticClass: "popInsufficientBalance-btn",
    on: {
      "click": () => _vm.$router.push('/earn')
    }
  }, [_vm._v("Earn")])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.insufficientStarOrTonBalanceShow
    },
    on: {
      "update:show": function ($event) {
        _vm.insufficientStarOrTonBalanceShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popInsufficientBalance"
  }, [_c('div', {
    staticClass: "popInsufficientBalance__title"
  }, [_vm._v("Insufficient balance")]), _c('div', {
    staticClass: "popInsufficientBalance-btns"
  }, [_vm.isCheckBtn ? _c('div', {
    staticClass: "popInsufficientBalance-btn",
    on: {
      "click": _vm.onPayCheckBtn
    }
  }, [!_vm.isCheckLoading ? [_vm._v("Check")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2) : _c('div', {
    staticClass: "popInsufficientBalance-btn",
    on: {
      "click": _vm.onDeposit
    }
  }, [!_vm.priceList[_vm.rowKey]?.isLoading ? [_vm._v("Deposit")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };